import React, {useState} from "react";
import emptyDocumentIcon from "../../../img/emptyDocumentCargoCaseIcon.svg";
import addPlusIcon from "../../../img/addPlusIcon.svg";
import uploadIcon from "../../../img/uploadIcon.svg";
import useAuth from "../../../utils/CustomHooks/useAuth/useAuth";
import useOnShowCreateDocButton from "../../../utils/CustomHooks/useOnShowCreateDocButton/useOnShowCreateDocButton";

const CreateNewDocuments = (props) => {

    const { auth } = useAuth();

    const {
        handeClickCreateNew,
        handeClickUpLoadFile,
        hiddenUploadBtn,
        hiddenButtons,
        errorMessage,
        cargoCaseDocument,
        isNewDocCargoCase,
        activeDocumentNotFound
    } = props;

    const [isShowCreateBtn, setShowCreateBtn] = useOnShowCreateDocButton(auth, cargoCaseDocument, isNewDocCargoCase, activeDocumentNotFound);

    return (
            <div className="create-new-documents">
                <img className="create-new-documents__empty-document-icon" src={emptyDocumentIcon} alt={'иконка пустой документ'}/>
                <p className="create-new-documents__title">Documents not found</p>
                <p className="create-new-documents__message">It will appear when you create them here</p>
                <div className={hiddenButtons ? "create-new-documents__buttons-block hide" : "create-new-documents__buttons-block"}>
                    {/*{isShowCreateBtn && <div onClick={handeClickUpLoadFile} className={hiddenUploadBtn ? "create-new-documents__upload-btn" : "create-new-documents__upload-btn hide"}>*/}
                    {/*    <img src={uploadIcon} alt={'иконка плюс'} />*/}
                    {/*    <p>Upload file</p>*/}
                    {/*</div>}*/}
                    {isShowCreateBtn && <div onClick={handeClickCreateNew} className="create-new-documents__create-btn">
                        <img src={addPlusIcon} alt={'иконка плюс'} />
                        <p>Create new</p>
                    </div>}
                </div>
                <p className={'create-new-documents__error-message'}>{errorMessage}</p>
            </div>
    )
}
export default CreateNewDocuments;